/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShipmentActivityView } from '../models/ShipmentActivityView';
import type { ShipmentAllocationMethodRequest } from '../models/ShipmentAllocationMethodRequest';
import type { ShipmentArchiveListView } from '../models/ShipmentArchiveListView';
import type { ShipmentCommentRequest } from '../models/ShipmentCommentRequest';
import type { ShipmentCommentView } from '../models/ShipmentCommentView';
import type { ShipmentCostBreakdownView } from '../models/ShipmentCostBreakdownView';
import type { ShipmentCostComponentRequest } from '../models/ShipmentCostComponentRequest';
import type { ShipmentCostsUpdateRequest } from '../models/ShipmentCostsUpdateRequest';
import type { ShipmentCountryView } from '../models/ShipmentCountryView';
import type { ShipmentCreateRequest } from '../models/ShipmentCreateRequest';
import type { ShipmentDashboardView } from '../models/ShipmentDashboardView';
import type { ShipmentDetailView } from '../models/ShipmentDetailView';
import type { ShipmentDocumentView } from '../models/ShipmentDocumentView';
import type { ShipmentIncotermView } from '../models/ShipmentIncotermView';
import type { ShipmentItemRequest } from '../models/ShipmentItemRequest';
import type { ShipmentItemView } from '../models/ShipmentItemView';
import type { ShipmentLabelListView } from '../models/ShipmentLabelListView';
import type { ShipmentLabelRequest } from '../models/ShipmentLabelRequest';
import type { ShipmentLabelUpdateRequest } from '../models/ShipmentLabelUpdateRequest';
import type { ShipmentLabelView } from '../models/ShipmentLabelView';
import type { ShipmentListView } from '../models/ShipmentListView';
import type { ShipmentMessageView } from '../models/ShipmentMessageView';
import type { ShipmentStatusBoardView } from '../models/ShipmentStatusBoardView';
import type { ShipmentStatusRequest } from '../models/ShipmentStatusRequest';
import type { ShipmentTrackerSettingsRequest } from '../models/ShipmentTrackerSettingsRequest';
import type { ShipmentTrackerSettingsView } from '../models/ShipmentTrackerSettingsView';
import type { ShipmentTransportProfileRequest } from '../models/ShipmentTransportProfileRequest';
import type { ShipmentTransportProfileView } from '../models/ShipmentTransportProfileView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShipmentTrackerService {
    /**
     * List transport profiles
     * @returns ShipmentTransportProfileView Transport profiles
     * @throws ApiError
     */
    public static getAppShipmentTrackerTransportProfiles(): CancelablePromise<Array<ShipmentTransportProfileView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/transport-profiles',
        });
    }
    /**
     * Create a custom transport profile
     * @param requestBody
     * @returns ShipmentTransportProfileView Created profile
     * @throws ApiError
     */
    public static postAppShipmentTrackerTransportProfilesCreate(
        requestBody: ShipmentTransportProfileRequest,
    ): CancelablePromise<ShipmentTransportProfileView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/transport-profiles',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List incoterms
     * @returns ShipmentIncotermView Incoterms
     * @throws ApiError
     */
    public static getAppShipmentTrackerIncoterms(): CancelablePromise<Array<ShipmentIncotermView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/incoterms',
        });
    }
    /**
     * List countries (ISO alpha-2)
     * @returns ShipmentCountryView Countries
     * @throws ApiError
     */
    public static getAppShipmentTrackerCountries(): CancelablePromise<Array<ShipmentCountryView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/countries',
        });
    }
    /**
     * List active shipments (paginated)
     * @param status Execution status filter (comma-separated, e.g. progress,in_transit)
     * @param page
     * @param limit
     * @returns ShipmentListView Paginated shipments
     * @throws ApiError
     */
    public static getAppShipmentTrackerList(
        status?: string,
        page: number = 1,
        limit: number = 20,
    ): CancelablePromise<ShipmentListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments',
            query: {
                'status': status,
                'page': page,
                'limit': limit,
            },
            errors: {
                403: `Access denied`,
            },
        });
    }
    /**
     * Create a shipment (draft or saved)
     * @param requestBody
     * @returns ShipmentDetailView Created shipment
     * @throws ApiError
     */
    public static postAppShipmentTrackerCreate(
        requestBody: ShipmentCreateRequest,
    ): CancelablePromise<ShipmentDetailView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/shipments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
                403: `Access denied`,
            },
        });
    }
    /**
     * Export active shipments as CSV
     * @returns any CSV file
     * @throws ApiError
     */
    public static getAppShipmentTrackerExport(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/export',
            errors: {
                403: `Access denied`,
            },
        });
    }
    /**
     * Get a shipment
     * @param id
     * @returns ShipmentDetailView Shipment detail
     * @throws ApiError
     */
    public static getAppShipmentTrackerGet(
        id: string,
    ): CancelablePromise<ShipmentDetailView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Update a shipment
     * @param id
     * @param requestBody
     * @returns ShipmentDetailView Updated shipment
     * @throws ApiError
     */
    public static putAppShipmentTrackerUpdate(
        id: string,
        requestBody: ShipmentCreateRequest,
    ): CancelablePromise<ShipmentDetailView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/shipment-tracker/shipments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
                404: `Not found`,
            },
        });
    }
    /**
     * Permanently delete a shipment (active or archived)
     * @param id
     * @returns ShipmentMessageView Deleted
     * @throws ApiError
     */
    public static deleteAppShipmentTrackerDelete(
        id: string,
    ): CancelablePromise<ShipmentMessageView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/shipment-tracker/shipments/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Change execution status
     * @param id
     * @param requestBody
     * @returns ShipmentDetailView Updated shipment
     * @throws ApiError
     */
    public static patchAppShipmentTrackerStatus(
        id: string,
        requestBody: ShipmentStatusRequest,
    ): CancelablePromise<ShipmentDetailView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/shipment-tracker/shipments/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Get cost breakdown incl. per-product landed cost (requires financials_read)
     * @param id
     * @returns ShipmentCostBreakdownView Cost breakdown
     * @throws ApiError
     */
    public static getAppShipmentTrackerCostBreakdown(
        id: string,
    ): CancelablePromise<ShipmentCostBreakdownView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/{id}/cost-breakdown',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Set planned/actual amounts of the fixed cost components (requires write + financials_read)
     * @param id
     * @param requestBody
     * @returns ShipmentCostBreakdownView Updated cost breakdown
     * @throws ApiError
     */
    public static patchAppShipmentTrackerCostsPatch(
        id: string,
        requestBody: ShipmentCostsUpdateRequest,
    ): CancelablePromise<ShipmentCostBreakdownView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/shipment-tracker/shipments/{id}/costs',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Set the container allocation method (requires write + financials_read)
     * @param id
     * @param requestBody
     * @returns ShipmentCostBreakdownView Recalculated cost breakdown
     * @throws ApiError
     */
    public static patchAppShipmentTrackerAllocationMethod(
        id: string,
        requestBody: ShipmentAllocationMethodRequest,
    ): CancelablePromise<ShipmentCostBreakdownView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/shipment-tracker/shipments/{id}/allocation-method',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Method unavailable for this container`,
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Add a user-defined cost component row (requires write + financials_read)
     * @param id
     * @param requestBody
     * @returns ShipmentCostBreakdownView Updated cost breakdown
     * @throws ApiError
     */
    public static postAppShipmentTrackerCostComponentAdd(
        id: string,
        requestBody: ShipmentCostComponentRequest,
    ): CancelablePromise<ShipmentCostBreakdownView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/shipments/{id}/cost-components',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Delete a user-defined cost component row (requires write + financials_read)
     * @param id
     * @param componentId
     * @returns ShipmentCostBreakdownView Updated cost breakdown
     * @throws ApiError
     */
    public static deleteAppShipmentTrackerCostComponentDelete(
        id: string,
        componentId: string,
    ): CancelablePromise<ShipmentCostBreakdownView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/shipment-tracker/shipments/{id}/cost-components/{componentId}',
            path: {
                'id': id,
                'componentId': componentId,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Rename / re-price a user-defined cost component row (requires write + financials_read)
     * @param id
     * @param componentId
     * @param requestBody
     * @returns ShipmentCostBreakdownView Updated cost breakdown
     * @throws ApiError
     */
    public static patchAppShipmentTrackerCostComponentUpdate(
        id: string,
        componentId: string,
        requestBody: ShipmentCostComponentRequest,
    ): CancelablePromise<ShipmentCostBreakdownView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/shipment-tracker/shipments/{id}/cost-components/{componentId}',
            path: {
                'id': id,
                'componentId': componentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Add an item to a shipment
     * @param id
     * @param requestBody
     * @returns ShipmentItemView Created item
     * @throws ApiError
     */
    public static postAppShipmentTrackerItemAdd(
        id: string,
        requestBody: ShipmentItemRequest,
    ): CancelablePromise<ShipmentItemView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/shipments/{id}/items',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
                404: `Not found`,
            },
        });
    }
    /**
     * Delete a shipment item
     * @param id
     * @param itemId
     * @returns ShipmentMessageView Deleted
     * @throws ApiError
     */
    public static deleteAppShipmentTrackerItemDelete(
        id: string,
        itemId: string,
    ): CancelablePromise<ShipmentMessageView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/shipment-tracker/shipments/{id}/items/{itemId}',
            path: {
                'id': id,
                'itemId': itemId,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Update a shipment item
     * @param id
     * @param itemId
     * @param requestBody
     * @returns ShipmentItemView Updated item
     * @throws ApiError
     */
    public static patchAppShipmentTrackerItemUpdate(
        id: string,
        itemId: string,
        requestBody: ShipmentItemRequest,
    ): CancelablePromise<ShipmentItemView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/shipment-tracker/shipments/{id}/items/{itemId}',
            path: {
                'id': id,
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * List comments on a shipment (newest first)
     * @param id
     * @returns ShipmentCommentView Comments (newest first)
     * @throws ApiError
     */
    public static getAppShipmentTrackerCommentList(
        id: string,
    ): CancelablePromise<Array<ShipmentCommentView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/{id}/comments',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Post a comment on a shipment
     * @param id
     * @param requestBody
     * @returns ShipmentCommentView Posted comment
     * @throws ApiError
     */
    public static postAppShipmentTrackerCommentAdd(
        id: string,
        requestBody: ShipmentCommentRequest,
    ): CancelablePromise<ShipmentCommentView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/shipments/{id}/comments',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * List documents attached to a shipment (newest first)
     * @param id
     * @returns ShipmentDocumentView Documents (newest first)
     * @throws ApiError
     */
    public static getAppShipmentTrackerDocumentList(
        id: string,
    ): CancelablePromise<Array<ShipmentDocumentView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/{id}/documents',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Attach a document to a shipment (single file, max 5 MB)
     * @param id
     * @param formData
     * @returns ShipmentDocumentView Uploaded document
     * @throws ApiError
     */
    public static postAppShipmentTrackerDocumentUpload(
        id: string,
        formData: {
            file: Blob;
        },
    ): CancelablePromise<ShipmentDocumentView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/shipments/{id}/documents',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Error`,
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Download every document of a shipment as one ZIP
     * @param id
     * @returns any ZIP stream
     * @throws ApiError
     */
    public static getAppShipmentTrackerDocumentDownloadAll(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/{id}/documents/download-all',
            path: {
                'id': id,
            },
            errors: {
                400: `Shipment has no documents`,
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Download a shipment document
     * @param id
     * @param docId
     * @returns any File stream
     * @throws ApiError
     */
    public static getAppShipmentTrackerDocumentDownload(
        id: string,
        docId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/{id}/documents/{docId}/download',
            path: {
                'id': id,
                'docId': docId,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Delete a shipment document
     * @param id
     * @param docId
     * @returns ShipmentMessageView Deleted
     * @throws ApiError
     */
    public static deleteAppShipmentTrackerDocumentDelete(
        id: string,
        docId: string,
    ): CancelablePromise<ShipmentMessageView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/shipment-tracker/shipments/{id}/documents/{docId}',
            path: {
                'id': id,
                'docId': docId,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get shipment activity / change history
     * @param id
     * @returns ShipmentActivityView Activity events (newest first)
     * @throws ApiError
     */
    public static getAppShipmentTrackerActivity(
        id: string,
    ): CancelablePromise<Array<ShipmentActivityView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/shipments/{id}/activity',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Dashboard — active shipments (paginated) + recent activity + alerts
     * @param status Execution status filter (comma-separated, e.g. progress,in_transit)
     * @param page
     * @param limit
     * @returns ShipmentDashboardView Dashboard data
     * @throws ApiError
     */
    public static getAppShipmentTrackerDashboard(
        status?: string,
        page: number = 1,
        limit: number = 20,
    ): CancelablePromise<ShipmentDashboardView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/dashboard',
            query: {
                'status': status,
                'page': page,
                'limit': limit,
            },
            errors: {
                403: `Access denied`,
            },
        });
    }
    /**
     * Status board — 6 columns keyed by executionStatus (no drafts, no archived)
     * @returns ShipmentStatusBoardView Status board
     * @throws ApiError
     */
    public static getAppShipmentTrackerStatusBoard(): CancelablePromise<ShipmentStatusBoardView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/status-board',
            errors: {
                403: `Access denied`,
            },
        });
    }
    /**
     * List archived shipments (paginated)
     * @param status Execution status filter (comma-separated, e.g. progress,in_transit)
     * @param q Search by name or reference
     * @param order Sort direction: desc (Newest first) | asc (Oldest first)
     * @param page
     * @param limit
     * @returns ShipmentArchiveListView Archived shipments
     * @throws ApiError
     */
    public static getAppShipmentTrackerArchiveList(
        status?: string,
        q?: string,
        order: string = 'desc',
        page: number = 1,
        limit: number = 20,
    ): CancelablePromise<ShipmentArchiveListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/archive',
            query: {
                'status': status,
                'q': q,
                'order': order,
                'page': page,
                'limit': limit,
            },
            errors: {
                403: `Access denied`,
            },
        });
    }
    /**
     * Archive a shipment
     * @param id
     * @returns ShipmentMessageView Archived
     * @throws ApiError
     */
    public static postAppShipmentTrackerArchiveCreate(
        id: string,
    ): CancelablePromise<ShipmentMessageView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/shipments/{id}/archive',
            path: {
                'id': id,
            },
            errors: {
                400: `Error`,
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Restore a single archived shipment
     * @param archiveId
     * @returns ShipmentDetailView Restored
     * @throws ApiError
     */
    public static postAppShipmentTrackerArchiveRestore(
        archiveId: string,
    ): CancelablePromise<ShipmentDetailView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/archive/{archiveId}/restore',
            path: {
                'archiveId': archiveId,
            },
            errors: {
                403: `Access denied`,
                404: `Not found`,
            },
        });
    }
    /**
     * Restore all archived shipments for the owner
     * @returns ShipmentMessageView Restored all
     * @throws ApiError
     */
    public static postAppShipmentTrackerArchiveRestoreAll(): CancelablePromise<ShipmentMessageView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/archive/restore-all',
            errors: {
                403: `Access denied`,
            },
        });
    }
    /**
     * List shipment labels
     * @returns ShipmentLabelListView Labels
     * @throws ApiError
     */
    public static getAppShipmentTrackerLabelsList(): CancelablePromise<ShipmentLabelListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/labels',
        });
    }
    /**
     * Create a shipment label
     * @param requestBody
     * @returns ShipmentLabelView Created label
     * @throws ApiError
     */
    public static postAppShipmentTrackerLabelsCreate(
        requestBody: ShipmentLabelRequest,
    ): CancelablePromise<ShipmentLabelView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/shipment-tracker/labels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Duplicate name`,
            },
        });
    }
    /**
     * Delete a shipment label
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteAppShipmentTrackerLabelsDelete(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/shipment-tracker/labels/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a shipment label
     * @param id
     * @param requestBody
     * @returns ShipmentLabelView Updated label
     * @throws ApiError
     */
    public static patchAppShipmentTrackerLabelsUpdate(
        id: string,
        requestBody: ShipmentLabelUpdateRequest,
    ): CancelablePromise<ShipmentLabelView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/shipment-tracker/labels/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get shipment tracker settings
     * @returns ShipmentTrackerSettingsView Settings
     * @throws ApiError
     */
    public static getAppShipmentTrackerSettingsGet(): CancelablePromise<ShipmentTrackerSettingsView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/shipment-tracker/settings',
        });
    }
    /**
     * Save shipment tracker settings
     * @param requestBody
     * @returns ShipmentTrackerSettingsView Settings
     * @throws ApiError
     */
    public static putAppShipmentTrackerSettingsPut(
        requestBody: ShipmentTrackerSettingsRequest,
    ): CancelablePromise<ShipmentTrackerSettingsView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/shipment-tracker/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Soft-delete a custom transport profile
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteAppShipmentTrackerTransportProfilesDelete(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/shipment-tracker/transport-profiles/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a custom transport profile
     * @param id
     * @param requestBody
     * @returns ShipmentTransportProfileView Updated profile
     * @throws ApiError
     */
    public static patchAppShipmentTrackerTransportProfilesUpdate(
        id: string,
        requestBody: ShipmentTransportProfileRequest,
    ): CancelablePromise<ShipmentTransportProfileView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v2/api/shipment-tracker/transport-profiles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
